import React from 'react';
import { Grid } from '@nextiva/next-ui-components';

const ShadowUserRow = () => {
  const rows = [];

  for (let i = 0; i < 5; i++) {
    rows.push(
      <div
        className="m-shadow-user-list__shadow__table-row"
        key={`shadow_user_row${i}`}
      >
        <Grid container>
          <Grid item xs={4}>
            <div className="m-shadow-user-list__shadow__table-row__check-box"></div>
            <div className="m-shadow-user-list__shadow__table-row__avatar"></div>
            <div className="m-shadow-user-list__shadow__table-row__user-info"></div>
          </Grid>
          <Grid item xs={4}>
            <div className="m-shadow-user-list__shadow__table-row__data"></div>
          </Grid>
          <Grid item xs={4}>
            <div className="m-shadow-user-list__shadow__table-row__data"></div>
          </Grid>
        </Grid>
      </div>,
    );
  }

  return rows;
};

export const ShadowUserList = () => {
  return (
    <div className="m-shadow-user-list__shadow">
      <div className="m-shadow-user-list__shadow__table">
        <div className="m-shadow-user-list__shadow__table-header">
          <Grid container>
            <Grid item xs={4}>
              <div className="m-shadow-user-list__shadow__check-box"></div>
              <div className="m-shadow-user-list__shadow__labels__name"></div>
            </Grid>
            <Grid item xs={4}>
              <div className="m-shadow-user-list__shadow__labels__name"></div>
            </Grid>
            <Grid item xs={4}>
              <div className="m-shadow-user-list__shadow__labels__name"></div>
            </Grid>
          </Grid>
        </div>

        <ShadowUserRow></ShadowUserRow>
      </div>
    </div>
  );
};
